/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLeiRequestDto
 */
export interface UpdateLeiRequestDto {
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof UpdateLeiRequestDto
     */
    orgId: string;
    /**
     * Org lei
     * @type {string}
     * @memberof UpdateLeiRequestDto
     */
    lei: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateLeiRequestDto
     */
    scopedOrgId?: string;
}

/**
 * Check if a given object implements the UpdateLeiRequestDto interface.
 */
export function instanceOfUpdateLeiRequestDto(value: object): boolean {
    if (!('orgId' in value)) return false;
    if (!('lei' in value)) return false;
    return true;
}

export function UpdateLeiRequestDtoFromJSON(json: any): UpdateLeiRequestDto {
    return UpdateLeiRequestDtoFromJSONTyped(json, false);
}

export function UpdateLeiRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLeiRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'orgId': json['orgId'],
        'lei': json['lei'],
        'scopedOrgId': json['scopedOrgId'] == null ? undefined : json['scopedOrgId'],
    };
}

export function UpdateLeiRequestDtoToJSON(value?: UpdateLeiRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'orgId': value['orgId'],
        'lei': value['lei'],
        'scopedOrgId': value['scopedOrgId'],
    };
}

